var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 2.79086 2.79086 1 5 1H29C31.2091 1 33 2.79086 33 5V29C33 31.2091 31.2091 33 29 33H5C2.79086 33 1 31.2091 1 29V5Z",
    stroke: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4488 15.3448V8.72412H18.6557V15.3448H25.2764V17.5517H18.6557V24.1724H16.4488V17.5517H9.82812V15.3448H16.4488Z",
    fill: "#2E3135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0a74c4ad0ea4e3861ff8bc89e54d717a.svg";
export { ForwardRef as ReactComponent };